import { createLogger, setLoggerUser as setPackageLoggerUser } from '@gameglass/logger'
import posthog from 'posthog-js'
import { APP_VERSION, IS_DEV, LOG_LEVEL, POSTHOG_HOST, POSTHOG_KEY } from '@/constants'

export const logger = createLogger({
	serviceName: 'frontend',
	serviceVersion: APP_VERSION,
	level: LOG_LEVEL,
	// Dependency and legacy console output only matters locally; production
	// ships explicit logger.* calls alone.
	console: IS_DEV,
	captureConsole: IS_DEV,
	posthog: {
		token: POSTHOG_KEY,
		host: POSTHOG_HOST,
		// Records and exceptions carry the same distinct id and session id as
		// the SDK's events, so an issue links to its replay.
		client: posthog
	}
})

/** Attaches the signed-in user to every record and exception. Call with nothing on logout. */
export const setLoggerUser = (id?: string | number | null) => setPackageLoggerUser(id)
